export const COURSE_FIELDS =
  "id,record_id,path,title,main_image,coming_soon,maestro.full_name,badge.new,badge.text,badge.theme";
export const LESSON_FIELDS =
  "id,lesson.path,title,record_id,maestro.full_name,coming_soon,lesson.id,lesson.title,lesson.main_image,lesson.duration,lesson.position,lesson_count";
export const PORT_NUMBER = 443;
export const RECENT_SEARCH_DEBOUNCE_VALUE = 400;
export const RECENT_SEARCH_KEY = "bbcm-recent-searches";
export const COMMIT_RECENT_SEARCH_RESULT_WAIT_TIME = 4000;
export const MAX_NUMBER_OF_RECENT_SEARCHES = 5;
